var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('header-nav'),_c('div',{staticClass:"section clearfix"},[_c('router-view')],1),_c('div',{staticClass:"footer"},[_vm._v("\n    Copyright © 2008～2021 "+_vm._s(_vm.$t('message["1089"]'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }